import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import classnames from 'classnames';

var styles = {"file-name-body":"magritte-file-name-body___PTTMc_3-2-16","fileNameBody":"magritte-file-name-body___PTTMc_3-2-16","file-name-body_medium":"magritte-file-name-body_medium___sfmmq_3-2-16","fileNameBodyMedium":"magritte-file-name-body_medium___sfmmq_3-2-16","file-name":"magritte-file-name___ZSL2g_3-2-16","fileName":"magritte-file-name___ZSL2g_3-2-16"};

const parse = (file) => {
    const name = file.name;
    const parts = name.split('.');
    if (parts.length === 1) {
        return {
            name: parts[0],
            extension: '',
        };
    }
    const extension = parts.pop();
    return {
        // -1 из-за точки
        name: name.substring(0, name.length - (extension?.length || 0) - 1),
        extension: extension || '',
    };
};
const FileName = ({ file, isSizeMedium = false }) => {
    const { name, extension } = parse(file);
    return (jsxs("div", { className: classnames(styles.fileNameBody, { [styles.fileNameBodyMedium]: isSizeMedium }), children: [jsx("div", { className: styles.fileName, children: name }), extension && jsxs("div", { children: [".", extension] })] }));
};

export { FileName };
//# sourceMappingURL=FileName.js.map
